import React from "react";

import "./how-it-works.scss";

import asset1 from "./assets/asset1.svg";
import asset2 from "./assets/asset2.svg";
import asset3 from "./assets/asset3.svg";

const HowItWorksAza = () => {
  return (
    <section className="hiw hiw__wrapper">
      <div className="container">
        <div className="row">
          <div className="col">
            <h2>Using Azaform</h2>
            <p>
              Build simple online forms, share widely, and manage all responses in one place.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <img src={asset1} alt="create online form" className="hiw__illustration" />
            <h4>Create your form</h4>
            <p>
              Start from scratch or use templates to design forms for registrations, surveys, contact, and more.
            </p>
          </div>
          <div className="col">
            <img src={asset2} alt="share form via QR" className="hiw__illustration" />
            <h4>Share with anyone</h4>
            <p>
              Share via links or QR codes so people can access your form anywhere, on any device.
            </p>
          </div>
          <div className="col">
            <img src={asset3} alt="view form responses" className="hiw__illustration" />
            <h4>Collect and review responses</h4>
            <p>
              See submissions in a unified dashboard and export or analyze them as needed.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksAza;